import React from 'react'
import Indicator from './Indicator'
import InfoMessage from './InfoMessage'

 const PasswordStrength = ({ password, email, fname, lname }) => {
  return (
    <div>
        <Indicator password={password} />
        <InfoMessage password={password} email={email} fname={fname} lname={lname} />
    </div>
  )
}

export default PasswordStrength